<template>
  <div>
    <Bj :bjData="bjData" />
    <div class="asTxt">
      <div class="tit">关于米啦</div>
      <div style="font-weight: bold">
        米啦是一个以智慧教育为主体，以课程辅导为载体，
        在全球范围内服务公办教育，助力民办教育，探索 未来教育新模式的科技教育公司。
      </div>
    </div>
    <div class="homeBody">
      <div class="mobileTitle">让兴趣教育乘风破浪</div>
      <div class="mobileMiniTitle">兴趣让学习更高效</div>
      <div class="textBox">
        <div class="text">精准学习导航</div>
        <div>基于10万+学员行为数据，AI算法动态推荐适配课程</div>
        <div class="text">沉浸式学习引擎</div>
        <div>实时追踪技能提升轨迹，薄弱点自动标记</div>
      </div>
      <img class="phone" src="../../assets/pc/home/phone.png" mode="widthFix" alt="" />
      <div class="mobileTitle">为什么选择米啦</div>
      <div class="mobileMiniTitle">专业团队精心打造，全方位助力学习</div>
      <div class="detailsBox">
        <div class="navList_out">
          <div class="navList">
            <div
              class="item"
              @click="select(item, i)"
              v-for="(item, i) in navList"
              :key="i"
              :style="{
                'font-weight': i == navIndex ? 'bold' : '',
              }"
            >
              {{ item.title }}
              <div :class="i == navIndex ? 'index' : ''"></div>
            </div>
          </div>
        </div>
        <img class="detailsImg" :src="require('@/' + detailsImg)" alt="" />
        <!-- <button class="btn" @click="goToWebsite">查看详情</button> -->
      </div>
      <!-- <div class="mobileTitle">高考学习方案</div>
			<div class="mobileMiniTitle">
				优秀的学习方案，让学习事半功倍
			</div>
			<move />
			<button class="btn" @click="$router.push('/mobileGaokao')">
				查看更多
			</button> -->
    </div>
    <div class="mobileTitle">更多学员青睐的专业学习方案</div>
    <div class="mobileMiniTitle">看得见的严苛标准</div>
    <div class="learning_program_out">
      <div class="learning_program">
        <div
          class="learning_program_item"
          v-for="(item, i) in learningList"
          :key="i"
          v-show="i <= 1"
        >
          <img class="learning_program_img" :src="require('@/' + item.imgUrl)" alt="" />
          <div class="learning_program_title">
            {{ item.title }}
          </div>
          <div class="learning_program_des">{{ item.des }}</div>
          <div class="learning_program_introduce">
            {{ item.introduce }}
          </div>
        </div>
      </div>
      <div class="learning_program">
        <div
          class="learning_program_item"
          v-for="(item, i) in learningList"
          :key="i"
          v-show="i >= 2"
        >
          <img class="learning_program_img" :src="require('@/' + item.imgUrl)" alt="" />
          <div class="learning_program_title">
            {{ item.title }}
          </div>
          <div class="learning_program_introduce">
            {{ item.introduce }}
          </div>
        </div>
      </div>
    </div>
    <!-- <develop /> -->
  </div>
</template>

<script>
import Bj from "@/components/mobile/bj.vue";
// import move from '@/components/mobile/move.vue'
// import develop from "@/components/mobile/develop.vue";
export default {
  components: {
    Bj,
    // move,
    // develop,
  },
  data() {
    return {
      bjData: {
        imgUrl: "https://qn.juquedu.com/bj.png",
        title: "选择米啦",
        minTitle: "让学习更有趣",
      },
      navIndex: 0,
      navList: [
        {
          title: "用户第一",
          imgUrl: "assets/pc/home/introduceOne.png",
        },
        {
          title: "自主研发",
          imgUrl: "assets/pc/home/introduceTwo.png",
        },
        {
          title: "服务流程",
          imgUrl: "assets/pc/home/introduceThree.png",
        },
        // {
        //   title: "教学质量把控",
        //   imgUrl: "assets/pc/home/introduceFour.png",
        // },
        // {
        //   title: "品控把控",
        //   imgUrl: "assets/pc/home/introduceFive.png",
        // },
        // {
        //   title: "教研工作",
        //   imgUrl: "assets/pc/home/introduceSix.png",
        // },
      ],
      detailsImg: "assets/pc/home/introduceOne.png",
      learningList: [
        {
          imgUrl: "assets/pc/home/learning1.png",
          title: "严选精品课池",
          des: "",
          introduce: "每月引入 ​30+ 前沿新课\n淘汰末位 ​15% 旧课​",
        },
        {
          imgUrl: "assets/pc/home/learning2.png",
          title: "智能学习中枢",
          des: "",
          introduce: "行为分析引擎\n实时调优课表​",
        },
        {
          imgUrl: "assets/pc/home/learning3.png",
          title: "沉浸式掌握真技能",
          des: "",
          introduce: "手机观看，\n随看随学高清课程",
        },
        {
          imgUrl: "assets/pc/home/learning4.png",
          title: "兴趣共学",
          des: "",
          introduce: "高价值社交学习网络\n享受最新最优的课程",
        },
      ],
    };
  },
  methods: {
    select(item, i) {
      this.navIndex = i;
      this.detailsImg = item.imgUrl;
    },
    goToWebsite() {
      window.open("https://api.juquedu.com/website/index.html");
    },
  },
};
</script>

<style lang="scss" scoped>
.mobileTitle {
  box-sizing: border-box;
  padding: 0 18px;
}
.mobileMiniTitle {
  box-sizing: border-box;
  padding: 0 25px;
}
.asTxt {
  box-sizing: border-box;
  padding: 0 15px;
  height: 240px;
  width: 100%;
  background-color: #ff293e;
  color: #ffe8e8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: lighter;
  text-align: center;
  .tit {
    font-size: 24px;
    margin-bottom: 10px;
    color: #fff;
    font-weight: bold;
  }
}
.homeBody {
  font-size: 15px;
  .btn {
    display: block;
    margin: 54px auto 0 auto;
    width: 102px;
    height: 37px;
    background: #ff293e;
    box-shadow: 0px 2px 4px rgba(255, 77, 94, 0.3);
    border-radius: 8px;
    color: #ffffff;
    font-size: 14px;
  }
  .btn:active {
    background: #750c16;
  }
  .textBox {
    box-sizing: border-box;
    padding: 0 18px;
    margin: 32px 0;
    color: #5f6464;
    .text {
      color: #333333;
      display: flex;
      align-items: center;
      font-weight: bold;
      margin-top: 5px;
    }
    .text::before {
      content: "";
      height: 14px;
      margin-right: 10px;
      width: 2px;
      display: inline-block;
      background-color: #ff3838;
    }
  }
  .phone {
    width: 299px;
    margin: 0 auto;
  }
  .detailsBox {
    .navList_out {
      box-sizing: border-box;
      width: 100%;
      height: 30px;
      font-size: 15px;
      color: #333333;
      margin: 24px auto 0 auto;
      overflow-x: scroll;
      border-bottom: 1px solid #dde1e5;
      .navList {
        width: 100%;
        // height: 30px;
        margin: 0 auto;
        overflow-y: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .item {
          cursor: pointer;
          float: left;
          margin-right: 16px;
          .index {
            width: 12px;
            height: 3px;
            background: #ff293e;
            border-radius: 2px;
            margin: auto;
            content: "";
            position: relative;
            top: 5px;
            display: block;
            text-align: center;
            animation: fadeInLeft 0.3s ease 0.2s 1 both;
          }
        }
        .item:nth-child(2) {
          padding: 0 36px;
        }
      }
    }
    .detailsImg {
      display: block;
      margin: 27px auto 0;
      width: 345px;
      border-radius: 8px;
    }
  }
}
.learning_program_out {
  height: 584px;
  box-sizing: border-box;
  padding: 0 18px;
  .learning_program {
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .learning_program_item {
      width: 155px;
      display: flex;
      align-items: center;
      flex-direction: column;
      float: left;
      .learning_program_img {
        width: 108px;
        height: 108px;
        margin-top: 36px;
      }
      .learning_program_title {
        margin-top: 12px;
        font-size: 18px;
        font-weight: 800;
        color: #333333;
      }
      .learning_program_des {
        margin-top: 2px;
        font-size: 12px;
        color: #949494;
      }
      .learning_program_introduce {
        margin-top: 16px;
        font-size: 14px;
        color: #333333;
        text-align: center;
        white-space: pre-line; /*保留换行符*/
      }
    }
    .learning_program_item:nth-child(1) {
      margin-right: 29px;
    }
    .learning_program_item:nth-child(3) {
      margin-right: 29px;
    }
  }
}
</style>
